import * as types from '../types';

const OTP_TIMEOUT = 60; /* sec */

const initialState = {
  login: {
    loading: false,
    isAuthorized: false,
    error: null,
    showCaptcha: false,
    values: {
      email: '',
      username: '',
      remember_me: null,
      password: null
    }
  },
  reset: {
    email: '',
    username: '',
    timer: 0,
    loading: false,
    isResetting: false,
    error: null
  },
  otp: {
    loading: false,
    error: null,
    resend: {
      timer: 0,
      error: null
    }
  },
  set: {
    password: '',
    loading: false,
    error: null
  },
  registration: {
    loading: false,
    isRegistering: false,
    error: null,
    showCaptcha: false,
    promo_email_agreement: false,
    values: {
      email: '',
      username: '',
      password: null
    }
  },
  resend: {
    email: '',
    timer: 0,
    loading: false,
    isResend: false,
    error: null
  },
  ask: {
    fields: [],
    loading: false,
    needConfirm: false,
    error: null,
    promo_email_agreement: false,
    social_provider: null,
    email_from_provider: null,
    publisher_account: 0
  },
  captchaRegister: {
    error: null,
    success: null
  }
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_FIELDS:
      return {
        ...state,
        ask: {
          ...state.ask,
          fields: action.fields,
          social_provider: action.social_provider || null,
          email_from_provider: action.email_from_provider || null,
          publisher_account: action.publisher_account || 0
        }
      };
    case types.SOCIAL_PROVIDER_INFO:
      return {
        ...state,
        ask: {
          ...state.ask,
          social_provider: action.social_provider || null,
          email_from_provider: action.email_from_provider || null,
          publisher_account: action.publisher_account || 0
        }
      };

    case types.SET_EMAIL_PROMO:
      return {
        ...state,
        registration: {
          ...state.registration,
          promo_email_agreement: true
        },
        ask: {
          ...state.ask,
          promo_email_agreement: true
        }
      };

    case types.SET_EMAIL:
      return {
        ...state,
        login: {
          ...state.login,
          values: {
            ...state.login.values,
            email: action.email
          }
        },
        registration: {
          ...state.registration,
          values: {
            ...state.registration.values,
            email: action.email
          }
        },
        reset: {
          ...state.reset,
          email: action.email
        }
      };

    case types.SET_USERNAME:
      return {
        ...state,
        login: {
          ...state.login,
          values: {
            ...state.login.values,
            username: action.username
          }
        },
        registration: {
          ...state.registration,
          values: {
            ...state.registration.values,
            username: action.username
          }
        },
        reset: {
          ...state.reset,
          username: action.username
        }
      };

    case types.CLEAR_ERRORS:
      return {
        ...state,
        login: {
          ...state.login,
          error: null
        },
        reset: {
          ...state.reset,
          error: null
        },
        resend: {
          ...state.resend,
          error: null
        },
        set: {
          ...state.set,
          error: null
        },
        otp: {
          ...state.otp,
          error: null,
          resend: {
            ...state.otp.resend,
            error: null
          }
        },
        registration: {
          ...state.registration,
          error: null
        },
        ask: {
          ...state.ask,
          error: null
        }
      };

    // Login

    case types.LOGIN_ATTEMPT:
      return {
        ...state,
        login: {
          ...state.login,
          loading: true,
          values: action.user
        }
      };

    case types.LOGIN_STOP:
      return {
        ...state,
        login: {
          ...state.login,
          loading: false
        }
      };

    case types.LOGIN_FAILED:
      return {
        ...state,
        login: {
          ...state.login,
          loading: false,
          isAuthorized: false,
          error: action.error
        }
      };

    case types.LOGIN_SUCCESSFULLY:
      return {
        ...state,
        login: {
          ...state.login,
          isAuthorized: true,
          error: null,
          values: {
            ...state.login.values,
            password: null
          }
        }
      };

    // Reset Password

    case types.RESET_ATTEMPT:
      return {
        ...state,
        reset: {
          ...state.reset,
          email: action.user.email,
          loading: true
        }
      };

    case types.RESET_FAILED:
      return {
        ...state,
        reset: {
          ...state.reset,
          timer: 10,
          loading: false,
          error: action.error
        }
      };

    case types.RESET_SUCCESSFULLY:
      return {
        ...state,
        reset: {
          ...state.reset,
          timer: 10,
          loading: false,
          isResetting: true,
          error: null
        }
      };

    case types.RESET_SET_TIMER:
      return {
        ...state,
        reset: {
          ...state.reset,
          timer: action.count
        }
      };

    // Set Password

    case types.SET_ATTEMPT:
      return {
        ...state,
        set: {
          ...state.set,
          password: action.user.password,
          loading: true
        }
      };

    case types.SET_FAILED:
      return {
        ...state,
        set: {
          ...state.set,
          loading: false,
          error: action.error
        }
      };

    case types.SET_SUCCESSFULLY:
      return {
        ...state,
        set: {
          ...state.set,
          loading: false,
          error: null
        }
      };

    // Registration

    case types.REGISTRATION_ATTEMPT:
      return {
        ...state,
        registration: {
          ...state.registration,
          values: action.user,
          loading: true
        }
      };

    case types.REGISTRATION_STOP:
      return {
        ...state,
        registration: {
          ...state.registration,
          values: {
            ...state.registration.values,
            password: null
          },
          loading: false
        }
      };

    case types.REGISTRATION_FAILED:
      return {
        ...state,
        registration: {
          ...state.registration,
          loading: false,
          error: action.error
        }
      };

    case types.REGISTRATION_SUCCESSFULLY:
      return {
        ...state,
        registration: {
          ...state.registration,
          values: {
            ...state.registration.values,
            password: null
          },
          isRegistering: true,
          error: null
        },
        resend: {
          ...state.resend,
          isResend: true,
          email: action.resend.email
        }
      };

    case types.REGISTRATION_RESET:
      return {
        ...state,
        registration: initialState.registration
      };

    // Resend confirm

    case types.RESEND_CONFIRM_INIT:
      return {
        ...state,
        resend: {
          ...state.resend,
          isResend: true,
          email: action.email
        }
      };

    case types.RESEND_CONFIRM_CLEAR:
      return {
        ...state,
        resend: {
          ...state.resend,
          isResend: false,
          error: null
        }
      };

    case types.RESEND_CONFIRM_ATTEMPT:
      return {
        ...state,
        resend: {
          ...state.resend,
          loading: true
        }
      };

    case types.RESEND_CONFIRM_SUCCESS:
      return {
        ...state,
        resend: {
          ...state.resend,
          loading: false,
          timer: 10,
          isResend: true
        }
      };

    case types.RESEND_CONFIRM_ERROR:
      return {
        ...state,
        resend: {
          ...state.resend,
          loading: false,
          error: action.error
        }
      };

    case types.RESEND_CONFIRM_SET_TIMER:
      return {
        ...state,
        resend: {
          ...state.resend,
          timer: action.count
        }
      };
    // OTP

    case types.OTP_LOGIN_ATTEMPT:
      return {
        ...state,
        otp: {
          ...state.otp,
          loading: true
        }
      };

    case types.OTP_LOGIN_FAILED:
      return {
        ...state,
        otp: {
          ...state.otp,
          loading: false,
          error: action.error
        }
      };

    case types.OTP_LOGIN_SUCCESSFULLY:
      return {
        ...state,
        otp: {
          ...state.otp,
          loading: false,
          error: null
        }
      };

    case types.OTP_RESEND_ATTEMPT:
      return {
        ...state,
        otp: {
          ...state.otp,
          resend: {
            ...state.otp.resend,
            timer: OTP_TIMEOUT,
            error: null
          }
        }
      };

    case types.OTP_RESEND_TIMER_TICK: {
      const {timer} = state.otp.resend;
      return {
        ...state,
        otp: {
          ...state.otp,
          resend: {
            ...state.otp.resend,
            timer: timer > 0 ? timer - 1 : 0
          }
        }
      };
    }

    case types.OTP_RESEND_FAILED:
      return {
        ...state,
        otp: {
          ...state.otp,
          resend: {
            ...state.otp.resend,
            timer: 0,
            error: action.error
          }
        }
      };

    // Ask fields

    case types.ASK_ATTEMPT:
      return {
        ...state,
        ask: {
          ...state.ask,
          loading: true
        }
      };

    case types.ASK_FAILED:
      return {
        ...state,
        ask: {
          ...state.ask,
          loading: false,
          error: action.error
        }
      };

    case types.ASK_CONFIRM:
      return {
        ...state,
        ask: {
          ...state.ask,
          loading: false,
          needConfirm: true,
          error: null
        }
      };

    case types.ASK_SUCCESSFULLY:
      return {
        ...state,
        ask: {
          ...state.ask,
          loading: false,
          error: null
        }
      };

    case types.CAPTCHA_REGISTER_FAILED:
      return {
        ...state,
        registration: {
          ...state.registration,
          loading: false,
          error: null
        },
        captchaRegister: {
          error: action.error,
          success: null
        }
      };

    case types.CAPTCHA_REGISTER_SUCCESSFULLY:
      return {
        ...state,
        captchaRegister: {
          error: null,
          success: action.success
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/auth.js